import { render, staticRenderFns } from "./EllipsisAndLook.vue?vue&type=template&id=4b2bdb3a&scoped=true"
import script from "./EllipsisAndLook.vue?vue&type=script&lang=js"
export * from "./EllipsisAndLook.vue?vue&type=script&lang=js"
import style0 from "./EllipsisAndLook.vue?vue&type=style&index=0&id=4b2bdb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2bdb3a",
  null
  
)

export default component.exports